export const previewObject = {
  '.pdf': ({ src, ...rest }) => <iframe src={src} {...rest} />,
};

export const defaultPreview = ({ src, ...rest }) => <img src={src} alt='' {...rest} />;


export const previewImage = ({ ext, src, ...rest }) => previewObject[ext] && previewObject[ext]({ src, ...rest }) || defaultPreview({ src, ...rest });